import React from "react";
import "./card.css";
import Tilt from "react-parallax-tilt";

function Card(props) {
  return (
    <Tilt>
      <div className="work-card" data-tilt>
        <h2> {props.title} </h2>
        <p>( {props.role} )</p>

        <div className="links">
          <a href={props.website} target="__blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32"
              height="32"
              viewBox="0 0 32 32">
              <path d="M 15.96875 3.96875 C 9.351563 3.96875 3.96875 9.351563 3.96875 15.96875 C 3.96875 22.585938 9.351563 27.96875 15.96875 27.96875 C 22.585938 27.96875 27.96875 22.585938 27.96875 15.96875 C 27.96875 9.351563 22.585938 3.96875 15.96875 3.96875 Z M 15.96875 5.96875 C 20.683594 5.96875 24.625 9.210938 25.6875 13.59375 C 25.597656 13.765625 25.464844 13.90625 25.1875 13.90625 C 22.914063 13.90625 21.179688 6.34375 14.84375 6.34375 C 13.988281 6.34375 13.253906 6.429688 12.59375 6.5625 C 13.648438 6.183594 14.78125 5.96875 15.96875 5.96875 Z M 11.65625 8 C 14.765625 8 17.347656 11.304688 19.5 13.21875 C 21.507813 15 24.023438 17.066406 25.875 17.34375 C 25.792969 17.941406 25.652344 18.503906 25.46875 19.0625 C 23.15625 18.917969 20.730469 17.574219 18.25 15.9375 C 14.871094 13.710938 11.851563 11.03125 9.65625 11.03125 C 8.140625 11.03125 7.035156 12.15625 6.46875 12.875 C 7.042969 11.105469 8.089844 9.554688 9.46875 8.375 C 9.949219 8.179688 10.632813 8 11.65625 8 Z M 8.03125 19.40625 C 9.863281 19.40625 13.148438 22.625 20.4375 22.625 C 21.882813 22.625 23.160156 22.277344 23.90625 22.03125 C 23.269531 22.867188 22.519531 23.589844 21.65625 24.1875 C 20.863281 24.402344 19.792969 24.59375 18.40625 24.59375 C 15.335938 24.59375 13.785156 23.625 12.3125 23.625 C 11.332031 23.625 11.375 24.386719 11.5 24.90625 C 9.402344 23.859375 7.71875 22.128906 6.78125 19.96875 C 6.992188 19.679688 7.359375 19.40625 8.03125 19.40625 Z"></path>
            </svg>
          </a>
          <a href={props.linkedin} target="__blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32"
              height="32"
              viewBox="0 0 32 32">
              <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M10.496,8.403 c0.842,0,1.403,0.561,1.403,1.309c0,0.748-0.561,1.309-1.496,1.309C9.561,11.022,9,10.46,9,9.712C9,8.964,9.561,8.403,10.496,8.403z M12,20H9v-8h3V20z M22,20h-2.824v-4.372c0-1.209-0.753-1.488-1.035-1.488s-1.224,0.186-1.224,1.488c0,0.186,0,4.372,0,4.372H14v-8 h2.918v1.116C17.294,12.465,18.047,12,19.459,12C20.871,12,22,13.116,22,15.628V20z"></path>
            </svg>
          </a>
          <a href={props.instagram} target="__blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="30"
              height="30"
              viewBox="0 0 32 32">
              <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"></path>
            </svg>
          </a>
        </div>
        <p>{props.description}</p>
        <a href="#" className="btn" target="__blank">
          {props.duration}
        </a>
      </div>
    </Tilt>
  );
}

export default Card;
